<template>
    <section class='header'>
        <div class='bg'></div>
        <div class='main'>
            <template v-if="devId!==-1">
                <div class='media'>
                    <img src="../../../assets/default.png" alt="">
                </div>
                <div class='inner'>
                    <div class='title'>
                        <div class='content'>
                            <div class='name'>{{devName}}</div>
                            <div class='status' :class="{online:devStatus}">{{devStatus?'在线':'离线'}}</div>
                        </div>
                        <div class='action' :class="{change:devCount>1}">
                            <span v-if="devCount>1" @click="changeDevice">切换设备</span>
                            <span v-else @click="addDevice">+&nbsp;添加设备</span>
                        </div>
                    </div>
                    <div class='text'>
                        <div class="content">
                            <div class='version' v-if='devStatus'>
                                设备信息：V.{{Number(devVersion.substr(devVersion.length-3))}}
                            </div>
                            <div class='error-msg' v-else>设备未连接</div>
                            <div class='penInfo'>
                                <template v-if='!penInfoError'>
                                    <template v-if='devStatus && penStatus'>
                                        {{penInfo}}
                                    </template>
                                    <template v-else>
                                        <span class='error-msg'>点读笔未连接</span>
                                    </template>
                                </template>
                                <template v-else>
                                    <span class='error-msg'>{{penInfoError}}</span>
                                </template>
                            </div>
                            <div v-if='devStatus && penStatus'>序列号：{{imbcode}}</div>
                        </div>
                        <div class="status" v-if='devStatus && devCanUpdate'>
                            <div class='btn-status' @click="updateDevice">更新</div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class='add-device' @click="addDevice">
                    +&nbsp;添加设备
                </div>
            </template>
        </div>
    </section>
</template>

<script>
  import { f7Link, f7Button, f7Chip } from 'framework7-vue'
  import { mapState } from 'vuex'

  export default {
    props: {
      devId: [Number, String],
      devName: String,
      devCanUpdate: {
        type: Boolean,
        default: false
      },
      devStatus: Boolean,
      penInfoError: [Object, String],
      penInfo: String,
      penStatus: Boolean,
      existDev: Boolean,
      devVersion: String,
      devCount: Number
    },
    name: '',
    methods: {
      addDevice () {
        this.$emit('addDevice')
      },
      changeDevice () {
        this.$f7router.navigate('/device/list')
      },
      updateDevice () {
        this.$emit('updateDevice')
      }
    },
    computed: {
      ...mapState({
        imbcode: ({downLoader}) => downLoader.imbcode
      })
    },
    components: {f7Link, f7Button, f7Chip}
  }
</script>

<style lang="scss" scoped type="text/css">
    @import "header.scss";
</style>